var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "column-sorting" },
    [
      _c("font-awesome-icon", {
        staticClass: "up",
        class: { active: _vm.isActive(1) },
        attrs: { icon: "caret-up" },
        on: {
          click: function ($event) {
            return _vm.sort(1)
          },
        },
      }),
      _c("font-awesome-icon", {
        staticClass: "down",
        class: { active: _vm.isActive(-1) },
        attrs: { icon: "caret-down" },
        on: {
          click: function ($event) {
            return _vm.sort(-1)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }